import React from 'react';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modal, Timeline } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useGetUsersByIdsQuery } from '../../../../../../redux/services/users';

const isStudent = (id, users) => {
  const user = users.find((user) => user.person_id === id);
  if (user && user.mail.includes('stud')) {
    return true;
  }
  return false;
};

const StatusTimelineModal = ({
  visible,
  toggleModal,
  title,
  data,
  isLoading,
}) => {
  const { t } = useTranslation();

    // Ensure data is an array before using map
    const safeData = Array.isArray(data) ? data : [];
    const userIds = safeData.map(item => item.person_id);
    const { data: users, isLoading: isLoadingUsers } = useGetUsersByIdsQuery(userIds, { skip: userIds.length === 0 });

  const userMap = useMemo(() => {
    if (!users) return {};
    return users.reduce((map, user) => {
      map[user.person_id] =
        `${user.title_before || ''} ${user.first_name || ''} ${
          user.last_name || ''
        } ${user.title_after || ''}`;
      return map;
    }, {});
  }, [users]);

    const timelineItems = useMemo(() => {
        if (!safeData || safeData.length === 0) return [];
        if (users) {
            return safeData.map(item => ({
                children: (
                    <>
                        {`${item.applicationStatus} - ${dayjs(item.created_at).format('D.M.YYYY H:mm')}`}
                        <br/>
                        {`${userMap[item.person_id]}`}
                        <br/>
                        <div style={{ color: 'gray', fontStyle: 'italic' }}>
                            {`${item.note || ''}`}
                        </div>
                    </>
                    ),
                    color: item.applicationStatus === "Akceptovaná" ? 'green' :
                        (item.applicationStatus === "Zamietnutá" ? 'red' :
                        (isStudent(item.person_id, users) ?
                            (item.applicationStatus === "Zrušená" ? 'LightSalmon' :
                            item.applicationStatus === "Odoslaná" ? 'Khaki' :
                            'LightSkyBlue') :
                            (item.applicationStatus === "Zrušená" ? 'orange' :
                            item.applicationStatus === "Odoslaná" ? 'gold' :
                            'blue')))
            }));
        }
        return [];
    }, [safeData, users, userMap]);

    return (
        <Modal
            open={visible}
            title={title || t('História prihlášky')}
            onCancel={toggleModal}
            footer={null}
            width={800}
            loading={isLoading || isLoadingUsers}
        >
        {timelineItems && timelineItems.length > 0 ? (
            <Timeline
            mode={"alternate"}
            items={timelineItems}
            />
        ) : (
            <div style={{ textAlign: 'center', padding: '20px' }}>
                {t('Žiadna história')}
            </div>
        )}
    </Modal>
  );
};

StatusTimelineModal.propTypes = {
  visible: PropTypes.bool,
  toggleModal: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default StatusTimelineModal;
